import type { LayoutData } from '../lib/menus';
import type {
  CustomerCasePageFragment,
  GlobalModulesFragment,
  PageFragment,
  PostPageFragment,
} from '../wp-generated/types';
import { MODULE_FLEXIBLE } from './CmsPageAppRouter';
import ComparisonTable from './modules/ComparisonTableModule/ComparisonTableModule';
import CustomerCasesModule from './modules/CustomerCasesModule';
import EmployeesModule from './modules/EmployeesModule';
import Faq from './modules/FaqModule/FaqModule';
import { FeaturedPages, FeaturedPosts } from './modules/FeaturedModule';
import IframeModule from './modules/IframeModule';
import LatestPostsModule from './modules/LatestPostsModule';
import LatestResources from './modules/LatestResources';
import LogosModule from './modules/LogosModule';
import NewsLetterSignupModule from './modules/NewsletterSignupModule';
import NumbersModule from './modules/NumbersModule';
import PageAnchor from './modules/PageAnchor';
import PricingPlans from './modules/PricingPlansModule/PricingPlansModule';
import RelatedPosts from './modules/RelatedPosts';
import Reviews from './modules/ReviewsModule';
import TestimonialsModule from './modules/TestimonialsModule';
import TextBlocksModule from './modules/TextBlocksModule';
import TrialSignupModule from './modules/TrialSignupModule';
import Video from './modules/VideoModule';
import WaveModule from './modules/WaveModule';

export interface CmsPageProps {
  layoutData: LayoutData;
  currentLocale?: {
    locale: string;
    label: string;
  };
  page: PageFragment | CustomerCasePageFragment | PostPageFragment;
}

export function getModule(
  moduleData:
    | NonNullable<NonNullable<PageFragment['modules']>['flexibleModules']>[0]
    | NonNullable<GlobalModulesFragment['data']>[0],
  locale?: string,
) {
  switch (moduleData?.__typename) {
    case `${MODULE_FLEXIBLE}TextBlocksLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (TextBlocksModule)</div>
      ) : (
        <TextBlocksModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}LogosLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (LogosModule)</div>
      ) : (
        <LogosModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}TestimonialsLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (TestimonialsModule)</div>
      ) : (
        <TestimonialsModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}NumbersLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (NumbersModule)</div>
      ) : (
        <NumbersModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}LatestPostsLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (LatestPostsModule)</div>
      ) : (
        <LatestPostsModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}EmployeesLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (EmployeesModule)</div>
      ) : (
        <EmployeesModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}FeaturedPagesLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (FeaturedPages)</div>
      ) : (
        <FeaturedPages moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}FeaturedPostsLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (FeaturedPosts)</div>
      ) : (
        <FeaturedPosts moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}ReviewsLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (Reviews)</div>
      ) : (
        <Reviews moduleData={moduleData} locale={locale} />
      );

    case `${MODULE_FLEXIBLE}FaqLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (Faq)</div>
      ) : (
        <Faq moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}PricingPlansLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (PricingPlans)</div>
      ) : (
        <PricingPlans moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}ComparisonTableLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (ComparisonTable)</div>
      ) : (
        <ComparisonTable moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}VideoLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (Video)</div>
      ) : (
        <Video moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}FeaturedCustomerCasesLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (CustomerCasesModule)</div>
      ) : (
        <CustomerCasesModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}WaveLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (WaveModule)</div>
      ) : (
        <WaveModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}LatestResourcesLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (LatestResources)</div>
      ) : (
        <LatestResources moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}TrialSignupFormLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (TrialSignupModule)</div>
      ) : (
        <TrialSignupModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}RelatedPostsLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (RelatedPosts)</div>
      ) : (
        <RelatedPosts moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}IframeLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (IframeModule)</div>
      ) : (
        <IframeModule moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}PageAnchorLayout`:
      return moduleData.use2025Design ? (
        <div>new design placeholder (PageAnchor)</div>
      ) : (
        <PageAnchor moduleData={moduleData} />
      );

    case `${MODULE_FLEXIBLE}NewsletterLayout`:
      return <NewsLetterSignupModule moduleData={moduleData} />;

    default:
      return null;
  }
}
